import Button from "@mobi/ds/components/Button"
import Text from "@mobi/ds/components/Text"

import useCardMiddle from "./hooks"

import "./style.scss"

const CardMiddle = () => {
  const { handleTrackEvent } = useCardMiddle()
  return (
    <div className="middleCard">
      <Text as="h3" className="middleCard__title">
        ainda não é correntista?
      </Text>
      <Text as="p" className="middleCard__text">
        O Crédito com Garantia de Imóvel será liberado em sua conta corrente
        Itaú, por isso, durante o processo de contratação será necessário que
        você abra uma conta. Que tal sair na frente?
      </Text>
      <Button
        className="middleCard__button"
        tagName="a"
        href="https://www.itau.com.br/contas/conta-corrente/?utm_source=st&utm_medium=nd&utm_campaign=st-conv-nd-st-nd-all&utm_content=nd-nd-nd-iacnta-nd-pfaqu-MT00000834-cgiproposta&utm_term=cgi-x-status-marketplace&utm_sou=cgi&utm_med=x&utm_camp=status&utm_cont=marketplace&utm_ter=11"
        target="_blank"
        rel="noreferrer"
        fluid
        onClick={() => handleTrackEvent()}
      >
        abra sua conta
      </Button>
    </div>
  )
}

export default CardMiddle
